// @ts-nocheck
import { Column } from 'react-table'
import { SupplierActionsCell } from './SupplierActionsCell'
import { SupplierCustomHeader } from './SupplierCustomHeader'
import { SupplierSelectionHeader } from './SupplierSelectionHeader'
import { SupplierSelectionCell } from './SupplierSelectionCell'
import { Supplier } from '../../core/_models'
import { FormattedMessage } from 'react-intl'

const suppliersColumns: ReadonlyArray<Column<Supplier>> = [
  {
    Header: (props) => <SupplierSelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({ ...props }) => <SupplierSelectionCell id={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => (
      <SupplierCustomHeader
        tableProps={props}
        title={<FormattedMessage id='SUPPLIER.TABLE.COLUMN.SUPPLIERNAME' defaultMessage='Supplier Name' />}
        className='min-w-125px'
      />
    ),
    id: 'supplier_name',
    accessor: 'supplier_name',
  },
  {
    Header: (props) => (
      <SupplierCustomHeader
        tableProps={props}
        title={<FormattedMessage id='SUPPLIER.TABLE.COLUMN.CONTACTDETAILS' defaultMessage='Contact Details' />}
        className='min-w-150px'
      />
    ),
    id: 'contact_details',
    accessor: 'contact_details',
  },
  {
    Header: (props) => (
      <SupplierCustomHeader
        tableProps={props}
        title={<FormattedMessage id='SUPPLIER.TABLE.COLUMN.ADDRESS' defaultMessage='Address' />}
        className='min-w-200px'
      />
    ),
    id: 'address',
    accessor: 'address',
  },
  {
    Header: (props) => (
      <SupplierCustomHeader
        tableProps={props}
        title={<FormattedMessage id='SUPPLIER.TABLE.COLUMN.STATUS' defaultMessage='Status' />}
        className='min-w-100px'
      />
    ),
    id: 'status',
    accessor: 'status',
    Cell: ({ value }) => (
      <span className={`badge ${value ? 'badge-success' : 'badge-danger'}`}>
        {value ? 'Active' : 'Inactive'}
      </span>
    ),
  },
  {
    Header: (props) => (
      <SupplierCustomHeader
        tableProps={props}
        title={<FormattedMessage id='TABLE.GENERAL.ACTION' defaultMessage='Action' />}
        className='text-end min-w-100px'
      />
    ),
    id: 'actions',
    Cell: ({ ...props }) => <SupplierActionsCell id={props.data[props.row.index].id} />,
  },
]

export { suppliersColumns }
